import { DetailedHTMLProps, HTMLAttributes } from 'react';

import clsx from 'clsx';

import styles from './loader.module.scss';

type Props = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

/**
 *
 * Generic loader component. To override its properties use CSS variables:\
 * `--size`;\
 * `--border-width`;\
 * `--border-color`;
 */
export const Loader = ({ className, ...rest }: Props) => {
  const classes = clsx(styles.loader, className);

  return <div aria-description="loading status indicator" className={classes} {...rest} />;
};
